import { render, staticRenderFns } from "./TextAndNoteButton.vue?vue&type=template&id=9acb320e&scoped=true"
import script from "./TextAndNoteButton.vue?vue&type=script&lang=js"
export * from "./TextAndNoteButton.vue?vue&type=script&lang=js"
import style0 from "./TextAndNoteButton.vue?vue&type=style&index=0&id=9acb320e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9acb320e",
  null
  
)

export default component.exports